module.exports = __webpack_public_path__ + "media/images/raid_5_disks-42100d1c93771bf227eb8aef353a769d.svg";